import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {ExceptionMobileHeaderType} from '../../../header/constants';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {NewWindowHeaderProps} from './NewWindowHeaderProps.interface';

/** 새 창으로 뜬 경우에만 사용합니다. PC도 동일하게 사용되는 경우가 있어 Mobile 컨텍스트를 붙이지 않았습니다. */
export function NewWindowHeader({
  title,
  closeText = t('common_close_button'),
  headerType = ExceptionMobileHeaderType.NewWindow,
  onClickClose = () => {},
  onClickBack = () => {},
  className,
  ...props
}: NewWindowHeaderProps) {
  return (
    <div
      className={twMerge(
        'flex h-mobile_header_height_px w-full items-center justify-between bg-theme-bg-base px-15pxr',
        className
      )}
      {...props}
    >
      {headerType === ExceptionMobileHeaderType.NewWindowTwoDepth && (
        <div className="flex shrink-0 cursor-pointer items-center">
          <Icon
            type={IconType.NavigationBack}
            onClick={e => LOG_CLICK_EVENT('뒤로가기', e, onClickBack)}
          />
        </div>
      )}
      <Text className="font-medium2-bold text-theme-solid-100">{title}</Text>
      <button className="shrink-0" onClick={onClickClose}>
        <Text className="font-small1 text-theme-solid-60">{closeText}</Text>
      </button>
    </div>
  );
}
